export const ASSET_FIELDS = [
  { k: "immob_immateriali", it: "Immobilizzazioni immateriali", en: "Intangible fixed assets" },
  { k: "immob_materiali", it: "Immobilizzazioni materiali", en: "Tangible fixed assets" },
  { k: "immob_finanziarie", it: "Immobilizzazioni finanziarie", en: "Financial fixed assets" },
  { k: "rimanenze", it: "Rimanenze / Magazzino", en: "Inventory" },
  { k: "crediti_clienti", it: "Crediti verso clienti", en: "Trade receivables" },
  { k: "crediti_altri", it: "Altri crediti", en: "Other receivables" },
  { k: "liquidita", it: "Disponibilità liquide", en: "Cash & equivalents" },
  { k: "ratei_attivi", it: "Ratei e risconti attivi", en: "Accrued income" },
];

export const LIAB_FIELDS = [
  { k: "capitale_sociale", it: "Capitale sociale", en: "Share capital" },
  { k: "riserve", it: "Riserve", en: "Reserves" },
  { k: "fondi_rischi", it: "Fondi per rischi e oneri", en: "Provisions" },
  { k: "tfr", it: "TFR", en: "Severance (TFR)" },
  { k: "debiti_fin_breve", it: "Debiti finanziari a breve", en: "Short-term financial debt" },
  { k: "debiti_fin_lungo", it: "Debiti finanziari a lungo", en: "Long-term financial debt" },
  { k: "debiti_fornitori", it: "Debiti verso fornitori", en: "Trade payables" },
  { k: "debiti_tributari", it: "Debiti tributari e previdenziali", en: "Tax & social payables" },
  { k: "debiti_altri", it: "Altri debiti", en: "Other payables" },
  { k: "ratei_passivi", it: "Ratei e risconti passivi", en: "Accrued expenses" },
];

export const INCOME_FIELDS = [
  { k: "ricavi", it: "Ricavi delle vendite", en: "Sales revenue" },
  { k: "var_rimanenze_prod", it: "Variazione rimanenze prodotti", en: "Change in inventory" },
  { k: "altri_ricavi", it: "Altri ricavi e proventi", en: "Other income" },
  { k: "costi_materie", it: "Costi per materie prime", en: "Raw materials cost" },
  { k: "costi_servizi", it: "Costi per servizi", en: "Services cost" },
  { k: "costi_godimento", it: "Godimento beni di terzi", en: "Rent & leases" },
  { k: "costi_personale", it: "Costi per il personale", en: "Personnel cost" },
  { k: "ammortamenti", it: "Ammortamenti", en: "Depreciation & amortization" },
  { k: "accantonamenti", it: "Accantonamenti / svalutazioni", en: "Provisions / write-downs" },
  { k: "oneri_diversi", it: "Oneri diversi di gestione", en: "Other operating charges" },
  { k: "proventi_finanziari", it: "Proventi finanziari", en: "Financial income" },
  { k: "oneri_finanziari", it: "Oneri finanziari", en: "Financial charges (interest)" },
  { k: "rettifiche_finanziarie", it: "Rettifiche attività finanziarie", en: "Financial asset adjustments" },
  { k: "imposte", it: "Imposte sul reddito", en: "Income taxes" },
];

export const ALL_FIELD_KEYS = [...ASSET_FIELDS, ...LIAB_FIELDS, ...INCOME_FIELDS].map((f) => f.k);

export function emptyPeriod() {
  const o = {};
  ALL_FIELD_KEYS.forEach((k) => { o[k] = ""; });
  return o;
}

// Prefilled demo (Acme Srl) to speed up testing
export function demoPeriod() {
  return {
    immob_immateriali: 40000, immob_materiali: 500000, immob_finanziarie: 20000,
    rimanenze: 200000, crediti_clienti: 300000, crediti_altri: 30000, liquidita: 80000, ratei_attivi: 5000,
    capitale_sociale: 100000, riserve: 250000, fondi_rischi: 20000, tfr: 60000,
    debiti_fin_breve: 150000, debiti_fin_lungo: 300000, debiti_fornitori: 180000,
    debiti_tributari: 45000, debiti_altri: 30000, ratei_passivi: 5000,
    ricavi: 1500000, var_rimanenze_prod: 10000, altri_ricavi: 20000,
    costi_materie: 600000, costi_servizi: 300000, costi_godimento: 40000, costi_personale: 350000,
    ammortamenti: 80000, accantonamenti: 15000, oneri_diversi: 20000,
    proventi_finanziari: 3000, oneri_finanziari: 25000, rettifiche_finanziarie: 0, imposte: 40000,
  };
}
